import classnames from 'classnames/bind';
import styles from './facebookShareButton.module.scss';

const cx = classnames.bind(styles);

interface IFacebookShareButtonProps {
  title: string;
  url: string;
}

const FacebookShareButton = (props: IFacebookShareButtonProps) => {
  const { title, url } = props;

  return (
    <li>
      <a
        className={cx('btnShare', 'facebook')}
        role="button"
        href={`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={cx('hidden')}>share facebook</span>
      </a>
    </li>
  );
};

export default FacebookShareButton;
